/* global _ */

import api from './api';

const { noop } = _;

export default function( ids, callback ) {
	ids = ids instanceof Array ? ids : [ ids ];
	callback = callback || noop;

	api( 'innoway/items', { id_in: ids }, response => {
		callback( response.data );
	}, 'POST' );
}
